import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  CONTACT_ADDRESS_SEARCH_COLUMNS,

} from "./consts";
import { ContactAddressSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const ContactAddressSearchResults: React.FC<ContactAddressSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onGoogleMapClick,
    onWhatsAppClick,
    onViberClick,
    onCopyLinkClick,
    onDeleteClick
  } = props;


  const { t } = useTranslate();

  const columns = CONTACT_ADDRESS_SEARCH_COLUMNS(
    t,
    onGoogleMapClick,
    onWhatsAppClick,
    onViberClick,
    onCopyLinkClick,
    onDeleteClick
  );


  return (
    <>
      <TableSearch
        columns={columns}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(ContactAddressSearchResults);
